import SystemService from './system.service'

export default angular.module('road.service', [])
    .service('systemService', SystemService)
    .name